import { useHistory } from 'react-router-dom'

import menu_azul from '../../assets/icons/menu_azul.svg';
import surcursal_light from '../../assets/icons/sucursal.svg';
import surcursal_solid from '../../assets/icons/sucursal-solid.svg';
import CardOpciones from './cardOpciones.component';

export const CabezoteBajo = (
    {
        open,
        categoriasGlobal,
        history,
        close,
        setOpen,
        setclose,
        mostrarOpciones,
        handleMenuOptions,
        setMostrarOpciones,
    }
) => {

    return (
        /** Prueba de Cabezote abajo de la pantalla en celular version 1.0 */
        <div className="header box cabezote_bajo">
            <div className="logo_menu">

                <img src={menu_azul} onClick={() => { setOpen(!open) }} />

                <div
                    className="select-css aux"
                    style={{ justifyContent: "space-between" }}
                    onClick={handleMenuOptions}
                >
                    <p style={{ margin: "0" }}>Productos</p>
                </div>
                {/**Esto es importante? */}
                <CardOpciones
                    mostrarOpciones={mostrarOpciones}
                    setMostrarOpciones={setMostrarOpciones}
                    history={history}
                    categoriasGlobal={categoriasGlobal}
                    tipoCamino={false}
                />
            </div>
            <div className="align">
                <div className="icon-search icon_user activar" onClick={() => setclose(!close)}>
                    {
                        close
                            ?
                            <img
                                src={surcursal_light}
                                className="width_icon_cabezote"
                                alt=""
                            />
                            :
                            <img
                                src={surcursal_solid}
                                alt=""
                            />
                    }
                </div>
            </div>
        </div>
    )
}
